<template>
  <div class="template_carousel">
    <el-dialog
      title="视频模块"
      :visible.sync="show"
      width="700px"
      @close="closeFn"
      @closed="closedFn"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :show-close="false"
    >
      <div>
        <el-form
          :model="form"
          label-width="120px"
          :inline="false"
          size="normal"
          :rules="rules"
          ref="newFormRef"
        >
          <el-form-item label="模块名称：" prop="name">
            <el-input v-model="form.name" size="mini" maxlength="20" placeholder="请输入模块名称，最多20字"></el-input>
          </el-form-item>
          <div
            v-for="(item, index) in form.dataList"
            :key="index"
            class="pt-20 pr-20 mb-20"
            style="border:solid 1px #EEEEEE;"
          >
            <el-form-item label="排序：">
              <div class="disFlx disFlxAIC">
                <el-input-number
                  v-model="item.sort"
                  controls-position="right"
                  :min="1"
                  size="mini"
                  class="mr-10"
                  placeholder="排序数字"
                ></el-input-number>
                <span class="fz12" style="color:#999999;">数字越大排序越前</span>
              </div>
            </el-form-item>
            <el-form-item  label="视频: ">
              <upload-video  v-model="item.videoSrc" :max="2" :text="['视频大小500m以内', '视频格式mp4']"></upload-video>
            </el-form-item>
            <el-form-item label="跳转类型：" class="skip-type" required>
              <jumpType2 :Jumpurls="item.Jumpurl"></jumpType2>
            </el-form-item>
            <div class="tc mb-20">
              <el-button type="primary" size="mini" @click="addList">+增加视频</el-button>
              <el-button
                type="danger"
                size="mini"
                @click="removeList(index)"
                v-if="index !== 0"
              >-删除视频</el-button>
            </div>
          </div>
        </el-form>
        <div class="tc">
          <el-button type="primary" size="default" @click="seve">确定</el-button>
          <el-button size="default" @click="closeFn">取消</el-button>
        </div>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import jumpType2 from '@/components/jumpType/jumpType.vue'

export default {
  name: 'video',
  components: {
    UploadVideo: () => import('@/components/uploadVideo/index.vue'),
    jumpType2

  },
  props: {
    value: {
      type: Boolean,
      default: false
    },
    items: {
      type: Object,
      default: {}
    }
  },
  data () {
    return {
      form: {
        name: '', // 模块名称
        type: 3,
        dataList: [
          {
            sort: 1,
            Jumpurl: {
              url: null,
              id: null,
              classId: null,
              paramType: '0',
              value: ''
            },
            videoSrc: [],
            paramType: 0
          }
        ]
      },
      rules: {
        name: [{ required: true, message: '请输入模块名称', trigger: 'blur' }]
      }
    }
  },
  computed: {
    show: {
      get () {
        return this.value
      },
      set (newVal) {
        this.$emit('input', newVal)
      }
    }
  },
  watch: {
    show (val) {
      let that = this
      if (val) {
        this.form.name = this.items.name
        if (this.items.dataJson) {
          this.form = JSON.parse(JSON.stringify(this.items.dataJson))
        }
      }
    }
  },
  created () {},
  methods: {
    closeFn () {
      Object.assign(this.$data, this.$options.data())
      this.$emit('closeFn')
    },
    closedFn () {
      this.$refs.newFormRef.clearValidate()
    },
    // 新增图片
    addList () {
      this.form.dataList.push({
        sort: this.form.dataList.length + 1,
        Jumpurl: {
          url: null,
          id: null,
          classId: null,
          paramType: '0',
          value: ''
        },
        videoSrc: [],
        paramType: 0
      })
    },
    // 删除图片
    removeList (index) {
      this.form.dataList.splice(index, 1)
      this.form.dataList.forEach((item, index) => {
        item.sort = index + 1
      })
    },
    // 确定
    seve () {
      let that = this
      that.$refs.newFormRef.validate(valid => {
        if (valid) {
          let params = JSON.parse(JSON.stringify(that.items))
          //   console.log(params,'params1111111')
          params.name = that.form.name
          params.isHome = 1
          params.dataJson = that.form
          this.$emit('dataListG', params)
        }
      })
    }
  }
}
</script>
<style scoped>
.tc {
  text-align: center;
}
.mb-20 {
  margin-bottom: 20px !important;
}
</style>
